import React, { useState } from "react";
import { Switch, Form, Tooltip, message } from "antd";
import { organizerUseMutation } from "../hooks";
import { Localize } from "components/service";
import { localizeByKeyStatic } from "components/service/localize";
import { usePermissionByObject, useIsDeveloper } from "components/permissions";
import Organizers from "components/organizer";
import { EOrganizerStatus } from "../helpers/organizer-types-helper";

interface IOrganizerStatusFieldProps
{
    id: string;
    status: EOrganizerStatus;
    dafaultExhibition?: boolean;
}

const OrganizerStatusField: React.FC<IOrganizerStatusFieldProps> = ({ id, status }) => {
  const [ form ] = Form.useForm();
  const [ statusValue, setStatusValue ] = useState(status === EOrganizerStatus.ACTIVE);

  const { _setOrganizerCreateUpdate } = organizerUseMutation.createUpdate(
    id,
    false
  );

  const { hasPermission: hasChangeStatusPermission } = usePermissionByObject(Organizers.Const.permissions.CHANGE_STATUS);
  const isDeveloper = useIsDeveloper();

  const validateChangeStatusPermission = () => {
    if (!isDeveloper && !hasChangeStatusPermission) {
      message.error(localizeByKeyStatic('PERMISSION.Error_AccessDenied'));
      return false;
    }
    return true;
  };

  return (
    <Form form={form} className="">
      <div className="switch-holder">
        <Form.Item
          name="status"
          initialValue={status === EOrganizerStatus.ACTIVE}
          style={{ marginBottom: 0 }}
        >
          <Tooltip
            title={!hasChangeStatusPermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Organizers.Const.permissions.CHANGE_STATUS.slug)}` : undefined}
          >
            <Switch
              checked={statusValue}
              disabled={!hasChangeStatusPermission}
              onChange={(checked) => {
                if (!validateChangeStatusPermission()) {
                  return;
                }

                setStatusValue(checked);
                _setOrganizerCreateUpdate({
                  variables: {
                    input: {
                      id,
                      status: checked ? EOrganizerStatus.ACTIVE : EOrganizerStatus.CLOSED,
                    },
                  },
                });
              }}
            />
          </Tooltip>
        </Form.Item>

        {statusValue ? (
          <span
            style={{ color: "var(--switch_colorPrimary)" }}
            className="switch-status-text"
          >
            <Localize>GLOBAL.Text_Active</Localize>
          </span>
        ) : (
          <span
            style={{ color: "var(--switch_colorTextQuaternary)" }}
            className="switch-status-text"
          >
            <Localize>GLOBAL.Text_Blocked</Localize>
          </span>
        )}
      </div>
    </Form>
  );
};

export default OrganizerStatusField;
